<main class="palestra-page">
  <!-- HERO -->
  <section class="page-hero">
    <div class="container-xl pt-navfix">
      <div class="hero-card card-sami">
        <div class="row align-items-center g-4">
          <div class="col-12 col-lg-7">
            <h1 class="fw-bold mb-2">
              Pulizia palestre, centri sportivi e SPA a Pescara
            </h1>
            <p class="mb-0 hero-sub">
              Con <strong>SAMI Pulizie</strong> garantisci un ambiente sano,
              profumato e sicuro. Interventi mirati di
              <strong>igienizzazione, sanificazione e disinfezione</strong> per
              sale fitness, spogliatoi e aree umide.
              <strong>Sopralluogo gratuito</strong> e piani su misura.
            </p>

            <div class="d-flex flex-wrap gap-2 mt-3">
              <button class="btn-sami" (click)="navigateToPreventiviSito()">
                Richiedi sopralluogo gratuito
              </button>
              <a class="btn-sami-outline" href="tel:08554360">Chiama 085 54360</a>
            </div>

            <div class="hero-chips mt-4">
              <div class="chip">
                <i class="fa-solid fa-dumbbell"></i> Aree ad alto contatto
              </div>
              <div class="chip">
                <i class="fa-solid fa-droplet"></i> Zone umide & spogliatoi
              </div>
              <div class="chip">
                <i class="fa-solid fa-shield-virus"></i> Sanificazione
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-5">
            <div class="hero-media">
              <img
                src="assets/pulizia-palestre-attrezzature.webp"
                class="hero-img"
                alt="Pulizia e igienizzazione attrezzature palestra"
                loading="eager"
                fetchpriority="high"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- (1) SEZIONE 2 COLONNE -->
  <section class="section">
    <div class="container-xl">
      <div class="row g-4 align-items-start">
        <div class="col-12 col-lg-7">
          <h2 class="fw-bold mb-3">Servizi per palestre</h2>

          <p class="text-muted mb-3">
            In palestra l’igiene è essenziale: attrezzi, maniglie e superfici
            vengono toccate continuamente. Per questo creiamo piani di pulizia
            <strong>programmati</strong> e interventi <strong>straordinari</strong>
            nei momenti di maggior affluenza o dopo eventi.
          </p>

          <p class="text-muted mb-4">
            Lavoriamo con procedure specifiche per sale fitness, spogliatoi e
            ambienti umidi (SPA), riducendo odori e contaminazioni e mantenendo
            l’esperienza dei clienti sempre al top.
          </p>

          <ul class="checklist">
            <li>
              <i class="fa-solid fa-check"></i> Igienizzazione attrezzi, manubri,
              panche e macchinari
            </li>
            <li>
              <i class="fa-solid fa-check"></i> Disinfezione punti touch:
              maniglie, interruttori, corrimani
            </li>
            <li>
              <i class="fa-solid fa-check"></i> Pulizia spogliatoi, docce e
              sanitari
            </li>
            <li>
              <i class="fa-solid fa-check"></i> Lavaggio pavimenti e trattamenti
              antiscivolo (quando necessario)
            </li>
            <li>
              <i class="fa-solid fa-check"></i> Pulizia vetrate, reception e aree
              comuni
            </li>
            <li>
              <i class="fa-solid fa-check"></i> Deodorazione e mantenimento
              ambienti
            </li>
            <li>
              <i class="fa-solid fa-check"></i> Interventi extra: sanificazione
              certificabile
            </li>
          </ul>
        </div>

        <div class="col-12 col-lg-5">
          <div class="card-sami p-4">
            <h3 class="fw-bold mb-3">Aree di intervento</h3>

            <ul class="bullets">
              <li>Sale pesi e sale corsi</li>
              <li>Attrezzi, macchinari e superfici ad alto contatto</li>
              <li>Spogliatoi, docce e servizi igienici</li>
              <li>Reception e aree di attesa</li>
              <li>Vetrate e ingressi</li>
              <li>Zone wellness / SPA e ambienti umidi</li>
              <li>Scale e corridoi</li>
              <li>Magazzini (su richiesta)</li>
            </ul>

            <div class="note-box mt-3">
              <strong>Nota:</strong> concordiamo fasce orarie e frequenze per
              ridurre l’impatto su corsi e clienti.
            </div>

            <div class="mini-cta mt-3">
              <div class="mini-cta-title">Vuoi un piano su misura?</div>
              <div class="mini-cta-text">
                Sopralluogo gratuito e preventivo personalizzato.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- (2) COME FUNZIONA -->
  <section class="section section-soft">
    <div class="container-xl">
      <div class="process-wrap card-sami">
        <h2 class="text-center fw-bold mb-4">Come funziona</h2>

        <div class="row row-cols-1 row-cols-md-2 row-cols-xl-4 g-3">
          <div class="col">
            <div class="process-step">
              <div class="step-num">1</div>
              <div class="step-title">Sopralluogo</div>
              <div class="step-text">
                Valutiamo spazi, flussi e criticità (zone umide, attrezzi, sale corsi).
              </div>
            </div>
          </div>

          <div class="col">
            <div class="process-step">
              <div class="step-num">2</div>
              <div class="step-title">Preventivo</div>
              <div class="step-text">
                Definiamo frequenze, orari e attività incluse con costi chiari.
              </div>
            </div>
          </div>

          <div class="col">
            <div class="process-step">
              <div class="step-num">3</div>
              <div class="step-title">Attivazione</div>
              <div class="step-text">
                Avviamo il servizio anche in fasce serali/notturne (se richiesto).
              </div>
            </div>
          </div>

          <div class="col">
            <div class="process-step">
              <div class="step-num">4</div>
              <div class="step-title">Controllo qualità</div>
              <div class="step-text">
                Monitoraggio e miglioramenti continui per standard elevati.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- (3) CTA BLU -->
  <section class="section-cta cta-wide">
    <div class="container-xl text-center">
      <h2 class="cta-title">La tua palestra merita il massimo</h2>
      <p class="cta-text">
        Contattaci per un sopralluogo gratuito e un preventivo personalizzato senza impegno.
      </p>

      <div class="d-flex justify-content-center gap-2 flex-wrap mt-3">
        <button class="btn btn-light cta-btn" (click)="navigateToPreventiviSito()">
          Richiedi preventivo gratuito
        </button>
        <a class="btn btn-outline-light cta-btn" href="mailto:info@samipulizie.it">
          Scrivi una mail
        </a>
      </div>
    </div>
  </section>

  <!-- MAPPA -->
  <section class="section">
    <div class="container-xl">
      <div class="section-head text-center">
        <h2 class="fw-bold">Dove operiamo</h2>
        <p class="text-muted mb-0">Sede commerciale: Via Tirino 145, Pescara.</p>
      </div>

      <div class="col-12 col-md-10 col-lg-8 mx-auto mt-3">
        <div class="ratio ratio-16x9 map-shell">
          <iframe
            loading="lazy"
            allowfullscreen
            style="border: 0"
            referrerpolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2843.2073!2d14.2181475!3d42.4462893!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1331a6223b8afae7%3A0xe0f8329b5888d54d!2sVia%20Tirino%2C%20145%2C%20Pescara!5e0!3m2!1sit!2sit!4v1713538014550"
          ></iframe>
        </div>
      </div>
    </div>
  </section>

  <!-- WhatsApp -->
  <div class="position-fixed bottom-0 end-0 mb-4 me-4" style="z-index: 1050">
    <a
      href="https://wa.me/3515034934"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chatta su WhatsApp"
      class="btn btn-success rounded-circle btn-sm"
    >
      <i class="fa-brands fa-whatsapp fa-2x"></i>
    </a>
  </div>
</main>
